import { render, staticRenderFns } from "./HistoricoCard.vue?vue&type=template&id=4be72ac8&scoped=true&"
import script from "./HistoricoCard.vue?vue&type=script&lang=js&"
export * from "./HistoricoCard.vue?vue&type=script&lang=js&"
import style0 from "./HistoricoCard.vue?vue&type=style&index=0&id=4be72ac8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be72ac8",
  null
  
)

export default component.exports